export default function pick(list, key) {
  return list.map(value => value[key]);
}
